import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const K0 = (Math.floor(Math.random() * 10) + 1) * 1000; // 1000, 2000…
  const p = Math.floor(Math.random() * 8) + 5;            // 5–12%
  const n = Math.floor(Math.random() * 5) + 2;            // 2–6 lat
  const tax = Math.floor(Math.random() * 8) + 15;         // 15–22%

  const factor = 1 + p / 100;
  const brutto = K0 * Math.pow(factor, n);
  const netto = K0 + (brutto - K0) * (1 - tax / 100);

  return {
    type: "FindFinalAmountWithTaxTask",
    data: { K0, p, n, tax, brutto: +brutto.toFixed(2), netto: +netto.toFixed(2) }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { K0, p, n, tax } = data;

  return (
    <>
      <p>
        Kapitał początkowy <InlineMath math={`K_0 = ${K0}`} /> zł
        został ulokowany na lokacie z rocznym oprocentowaniem{" "}
        <InlineMath math={`${p}\\%`} /> na okres{" "}
        <InlineMath math={`${n}`} /> lat.
      </p>
      <p>
        Po zakończeniu lokaty od zysku potrącono podatek w wysokości{" "}
        <InlineMath math={`${tax}\\%`} />.
      </p>
      <p>
        Oblicz kapitał końcowy <InlineMath math={`K`} /> po opodatkowaniu.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="K"
      suffixLatex="\text{zł}"
    />
  );
}



export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = parseFloat(userAnswer.raw);
  if (isNaN(given)) return false;

  return Math.abs(given - data.netto) < 0.01;
}

export function renderAnswer({ data }) {
  const { netto } = data;

  const isApprox = !(Number.isInteger(netto) || netto === parseFloat(netto.toFixed(0)));
  const symbol = isApprox ? '\\approx' : '=';

  return (
    <InlineMath math={`K ${symbol} ${netto} \\, \\text{zł}`} />
  );
}

export function renderExplanation({ data }) {
  const { K0, p, n, tax, brutto, netto } = data;

  const factor = +(1 + p / 100).toFixed(2);
  const multiplier = Math.pow(factor, n);
  const multiplierRounded = +multiplier.toFixed(2);

  const gain = brutto - K0;
  const taxAmount = +(gain * tax / 100).toFixed(2);
  const afterTax = +(netto).toFixed(2);

  const isBruttoApprox = Math.abs(multiplier - multiplierRounded) > 1e-10;
  const bruttoSymbol = isBruttoApprox ? '\\approx' : '=';

  const isNettoApprox =
    Math.abs(netto - Math.round(netto)) > 1e-2 &&
    Math.abs(netto - parseFloat(netto.toFixed(0))) > 1e-2;

  const nettoSymbol = isNettoApprox ? '\\approx' : '=';

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Obliczamy kapitał końcowy brutto (przed opodatkowaniem):
      </p>
      <BlockMath math={`K_{brutto} = K_0 \\cdot \\left(1 + \\frac{p}{100}\\right)^n`} />
      <BlockMath math={`K_{brutto} = ${K0} \\cdot (${factor})^{${n}}`} />
      <BlockMath math={`K_{brutto} ${bruttoSymbol} ${brutto.toFixed(2)}`} />

      <p>
        <strong>Krok 2:</strong> Obliczamy podatek od zysku:
      </p>
      <BlockMath
        math={`Podatek = (${brutto.toFixed(2)} - ${K0}) \\cdot \\frac{${tax}}{100}`}
      />
      <BlockMath
        math={`Podatek = (${gain.toFixed(2)}) \\cdot (${(tax / 100).toFixed(2)})`}
      />
      <BlockMath math={`Podatek = ${taxAmount}`} />

      <p>
        <strong>Krok 3:</strong> Odejmujemy podatek od brutto:
      </p>
      <BlockMath
        math={`K_{netto} ${bruttoSymbol} ${brutto.toFixed(2)} - ${taxAmount}`}
      />
      <BlockMath
        math={`K_{netto} ${nettoSymbol} ${afterTax} \\, \\text{zł}`}
      />
    </div>
  );
}





export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  const val = parseFloat(userAnswer.raw);
  const isApprox = Math.abs(val - Math.round(val)) > 1e-2 &&
                   Math.abs(val - parseFloat(val.toFixed(0))) > 1e-2;
  const symbol = isApprox ? "\\approx" : "=";

  return <InlineMath math={`K ${symbol} ${val} \\, \\text{zł}`} />;
}
